import { useState } from 'react';
import { Box } from '@mui/material';
import { useSnackbar } from 'notistack';

import { Button } from '@components/button';
import { Dialog } from '@components/dialog/Dialog';
import Loading from '@components/Loading';
import { ToastType } from '@components/toast/ToastType.enum';
import { RatingReportJsonViewer } from '@pages/QuoteDetails/sidebarItems/summary/modals/RatingSummaryModal/RatingReportJsonViewer';
import { getDateFormatter, LongDateFormatWithoutSeconds } from '@utils/date';
import { format } from 'date-fns-tz';
import { isValid } from 'date-fns';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';
export type ViewQuoteRatingSummaryButtonProps = {
  ratingDetailsFileUrl: string;
};

export const ViewQuoteRatingSummaryButton = ({ ratingDetailsFileUrl }: ViewQuoteRatingSummaryButtonProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoadingReport, setIsLoadingReport] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [ratingReport, setRatingReport] = useState<any>();
  const [layoutPreferences] = useStore((state) => [state.layoutPreferences], shallow);
  const clockFormat = layoutPreferences.clockFormat;

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleGetRatingReport = async () => {
    setIsLoadingReport(true);
    fetch(ratingDetailsFileUrl)
      .then(async (response) => {
        const res = await response.json();

        if (res) {
          setRatingReport(res);
          setModalOpen(true);
        }
        setIsLoadingReport(false);
      })
      .catch((_e) => {
        setIsLoadingReport(false);
        enqueueSnackbar('Fetching Rating Report failed', {
          variant: ToastType.Error,
          persist: true,
        });
      });
  };

  const ratedDate = ratingReport ? (ratingReport.startedAt ? new Date(ratingReport.startedAt) : null) : null;
  const formattedDate =
    ratedDate && isValid(ratedDate) && format(ratedDate, getDateFormatter(clockFormat, LongDateFormatWithoutSeconds));

  return (
    <>
      <Dialog
        open={modalOpen}
        size='large'
        showBorders={false}
        title={`Rating Report ${formattedDate}`}
        handleCloseDialog={handleCloseModal}
        primaryBtnText='Close'
        primaryBtnAction={handleCloseModal}
      >
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              padding: '24px',
              height: '85%',
            }}
          >
            {ratingReport ? <RatingReportJsonViewer ratingReport={ratingReport} /> : <Loading />}
          </Box>
        </Box>
      </Dialog>

      <Button
        variant='text'
        sx={{ paddingLeft: '0px', marginTop: 0.5 }}
        isLoading={isLoadingReport}
        onClick={handleGetRatingReport}
        disableRipple
      >
        View Rating Report
      </Button>
    </>
  );
};
